import { useEffect, useState } from "react";
import API_BASE from "../config";
import { WorkshopProvider } from "../checklist";

// Ponte entre o Painel de Gestao e o modulo de Checklist.
//
// O checklist SEMPRE soube receber configuracao central: o WorkshopProvider
// aceita uma prop `config` e o mergeSettings() (checklist/lib/settingsDefaults.js)
// da prioridade a ela sobre o que a oficina salvou localmente -- e o
// getControlledFeatureFields() trava o campo contra alteracao pela tela de
// Configuracoes da oficina. Ate aqui ninguem passava nada: a tomada existia
// sem plugue.
//
// Este componente le `oficina_config_<tenant>.checklistConfig` -- a MESMA
// chave que ja guarda modulosAtivos, gravada pelo painel em
// Oficinas > Editar -- e entrega o objeto ao provider SEM TRADUCAO: o
// formato gravado la e exatamente o que o mergeSettings espera aqui.
//
// Pintura imediata: o valor tambem fica em localStorage, entao a tela nao
// "pisca" esperando a rede. Mesmo padrao que components/Layout.js ja usa
// para menu e tema.
//
// Falha de rede, 401 ou chave ausente => config null => valem os padroes de
// settingsDefaults.js. Nenhum caminho leva a tela quebrada.

const CACHE_PREFIX = "checklist_cfg_tenant_";

function lerCache(tenantId) {
  try {
    const raw = localStorage.getItem(CACHE_PREFIX + tenantId);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

function gravarCache(tenantId, cfg) {
  try {
    localStorage.setItem(CACHE_PREFIX + tenantId, JSON.stringify(cfg));
  } catch {
    // Modo privado ou cota cheia: seguir sem cache nao quebra nada, so
    // custa um flash na proxima abertura.
  }
}

export default function ChecklistConfigGate({ workshopId, workshopName, children }) {
  // IMPORTANTE: `config` precisa ser referencia ESTAVEL entre renders.
  // SettingsProvider memoiza `settings` com [stored, externalConfig]; um
  // objeto literal novo a cada render invalidaria esse memo continuamente.
  // Por isso o valor vem do state (so muda quando setCfg e chamado) e nunca
  // de um `cfg || {}` montado no return.
  const [cfg, setCfg] = useState(() => lerCache(workshopId));

  useEffect(() => {
    let vivo = true;
    const token =
      sessionStorage.getItem("access_token") || localStorage.getItem("access_token");
    // GET /config/{key} para chaves por-tenant exige autenticacao
    // (auditoria de 11/08/2026) -- mesmo cabecalho que App.js/syncPlano usa.
    fetch(API_BASE + "/api/v1/config/oficina_config_" + workshopId, {
      headers: token ? { Authorization: "Bearer " + token } : {},
    })
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => {
        if (!vivo) return;
        const novo = (d && d.value && d.value.checklistConfig) || null;
        setCfg(novo);
        gravarCache(workshopId, novo);
      })
      .catch(() => {
        // Sem rede: segue com o cache (ou com o padrao). Silencioso de
        // proposito -- este componente nunca deve impedir o checklist de abrir.
      });
    return () => {
      vivo = false;
    };
  }, [workshopId]);

  return (
    <WorkshopProvider workshopId={workshopId} workshopName={workshopName} config={cfg}>
      {children}
    </WorkshopProvider>
  );
}
